export enum PlatformType {
  WIM = 'WIM',
  DETECTORS = 'DETECTORS',
}

export default PlatformType;
